// extracted by mini-css-extract-plugin
export default {"rdwWrapper":"RdwVoting_rdwWrapper__pPoxm","rewardMessage":"RdwVoting_rewardMessage__aCNxc"};